import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Logo from "../../assets/images/header/SIA Logo.png";
import Image from "next/image";
import { tnpscmainsmock } from "../../components/Service/resultdownload"; 
import { useState, useRef } from 'react';
import Head from "next/head";

export default function HallTicketPage() {
  const [RegMobile, setRegMobile] = useState('');
  const [submittedData, setSubmittedData] = useState(null);
  const pdfRef = useRef();

  // Example submit handler with enhanced debugging & error handling
  async function downloapdfsubmit(e)
  {
    e.preventDefault();
    const mobile={RegMobile}; 
  console.log(mobile);   
  
  tnpscmainsmock(mobile)
  .then((response) => {
    console.log("API Response:", response);
   console.log("API Response:", response.value);
    if(response.success===false)
    {
      alert(response.message);
      //document.getElementById("mobileNumber").reset();
    }
    else{
      setSubmittedData(response.value)
    }
   
  });
  console.log(mobile);
  //setSubmittedData(); 
  }

  // Handle PDF generation using html2canvas and jsPDF
  const generatePDF = async () => {
    if (typeof window === "undefined") return; // ensures we're in the browser
  
    const html2pdf = (await import("html2pdf.js")).default;
    const input = pdfRef.current;
    const opt = {
      margin: 10,
      filename: "Result.pdf",
      image: { type: "jpeg", quality: 0.50 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" }
    };
  
    html2pdf().set(opt).from(input).save().catch((error) => {
      console.error("Error generating PDF:", error);
    });
  };
  

  return (
    <>
    <Head>
        <meta name="robots" content="noindex,nofollow" />
        <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
        <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
        <title>TNPSC GROUP II MAIN MOCK TEST RESULT 2026</title>
    </Head>
      <Navbar title="home" />
      {/* <h4 className="pt-5 pb-4 text-center" style={{ fontFamily: "Switzer-Bold" ,fontsqize:"20px"}}>
          <span style={{color:"#df140dff"}}> Closed </span>
      </h4>*/}
           <div className="container p-4" style={{ backgroundColor: "#fff8ea" }}>
             
        <form onSubmit={downloapdfsubmit} className="mobile-label mb-4 col-md-7 mx-auto">
          <label htmlFor="mobileNumber">Enter your Register Mobile  Number / GRP II Registration No:</label>
          <input
            type="tel"
            name="mobileNumber"
            id="mobileNumber"
            required
            value={RegMobile}
            onChange={(e) => setRegMobile(e.target.value)}
            className="form-control mobile-input"
          />
          <button type="submit" className="btn btn-primary mt-3">
            Submit
          </button>
        </form>
         <p className="mobile-label mb-4 col-md-6 mx-auto text-danger"><b>Enquiry : +91 93068 16977</b></p>
      </div>

      { submittedData && (
    <div className="container mt-4 pt-4">
          {/* Button to Generate PDF */}
          <button type="button" onClick={generatePDF} className="download-button">
            Download Result
          </button>
          <div className="col-12">
            <div ref={pdfRef} className="mt-2 p-2 border rounded-lg bg-gray-600">
            <div className="row">
          {/* Logo Section */}
          
          <div className=" d-flex justify-content-center align-items-center pt-2">
            <Image
              src={Logo}
              alt="shankar ias logo"
              title="Shankar IAS Academy"
              className="img-fluid"
              style={{ width: '300px', height: 'auto' }}

            />
          </div>
    </div>

          {/* Title Section */}
        <div className="row">
          <div className="col-12 align-items-center pt-2">
            <div>
               
              <h5 className="text-center" style={{ fontFamily: "Switzer-Bold" ,fontsqize:"20px" }}>
                 TNPSC GRP II MAINS STATE LEVEL MOCK TEST
              </h5>
              <h5 className="text-center" style={{ fontFamily: "Switzer-Bold" }}>
               <span style={{color:"#df140dff"}}> RESULT </span>2026
              </h5> 
            </div>
          </div>
          </div>
        

        {/* Form Section */}
        <div className="formsection">
          <div className="fields">
            <table className="table">
              <thead>
                {/* <tr>
                  <th>Required Field</th>
                  <th>Candidate Details</th>
                  <th>Candidate’s Photo</th>
                </tr> */}
              </thead>
              <tbody>
                <tr>
                  <th>Name :</th>
                  <td>
                    <span className="input-field">{submittedData.name}</span>
                  </td>
                </tr>

                 <tr>
                  <th>Mobile No :</th>
                  <td>
                    <span className="input-field">{submittedData.mobileNo}</span>
                  </td>
                </tr>

                <tr>
                  <th>TNPSC Group II Reg. No :</th>
                  <td>
                    <span className="input-field">{submittedData.registerN}</span>
                  </td>
                </tr>
               
                {/* <tr>
                  <th>Paper2 :</th>
                  <td>
                    <span className="input-field">{submittedData.paperII}</span>
                  </td>
                </tr>
                <tr>
                  <th>Paper3 :</th>
                  <td>
                    <span className="input-field">{submittedData.paperIII}</span>
                  </td>
                </tr>
                <tr>
                  <th>paper4 :</th>
                  <td>
                    <span className="input-field">{submittedData.paperIV}</span>
                  </td>
                </tr> */}

                <tr>
                  <th><span style={{color:"#df140dff"}}>TOTAL MARKS : </span></th>
                  <td>
                    <span className="input-field">{submittedData.totalMarks}</span>
                  </td>
                </tr>
                 <tr>
                  <th><span style={{color:"#df140dff"}}>RANK : </span></th>
                  <td>
                    <span className="input-field">{submittedData.overallRank}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      

            </div>
          </div>
    </div>
        
      )}

      {/* Scoped CSS using JSX */}
      <style jsx>{`
        .container {
          width: 100%;
          max-width: 900px;
          margin: 0 auto;
          background-color: white;
          padding: 20px;
          border-radius: 10px;
          box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
        }
        .formsection {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 2rem;
        }
        .fields {
          width: 100%;
        }
        .table {
          width: 100%;
          border-collapse: collapse;
        }
        .table td {
          border: 1px solid #00000069;
          padding: 0.5rem;
          background-color: #ffffff;
          color: #161414;
          font-size: 14px;
        }
        th {
          font-family: "Switzer-Bold";
          border: 1px solid #00000069;
          padding: 0.5rem;
          background-color: #f2f2f2;
          font-size: 14px;
        }
        .input-field {
          font-family: Switzer-Medium;
        }
        .photo {
          text-align: center;
        }
        .download-button {
          background-color: red;
          color: white;
          padding: 0.5rem 1rem;
          border: none;
          border-radius: 0.25rem;
          cursor: pointer;
          transition: background-color 0.3s ease;
        }
        .download-button:hover {
          background-color: darkred;
        }

         .mobile-label {
          display: block;
          font-size: 16px;
           margin:10px;
       }
        .mobile-input {
        
          font-size: 16px;
          border: 1px solid #ccc;
          border-radius: 4px;
          width: 100%;
          box-sizing: border-box;
              margin: 10px 0px;
        }

          /* Mobile-specific styles */

        @media (max-width: 600px) {
            .container {
            padding: 10px;
            margin: 0 10px;
            }
            .formsection {
            flex-direction: column;
            }
            .table td,
            th {
            font-size: 14px;
            padding: 0.3rem;
            }
            .download-button {
            padding: 0.4rem 0.8rem;
            font-size: 14px;
            }
        }
      `}</style>

      <Footer />
    </>
  );
}
